



















import { Component, Vue } from 'vue-property-decorator';
@Component({
  props: {
    showskeleton: Boolean,
    label: String,
    value: String,
    labelskeletonpecentage: String,
    valueskeletonpecentage: String,
  },
})
export default class CardCell extends Vue {}
